<form [formGroup]="form" autocomplete="off" (ngSubmit)="onSubmit()" novalidate>
  <form-group-context label="Name" formControlName="name">
    <form-group-simple name="name" placeholder="Name"></form-group-simple>
  </form-group-context>


  <form-group-context label="Stores" formControlName="stores">
    <form-group-select entity="store"
                       bindLabel="name"
                       [multiple]="true"
                       [searchable]="true"
                       [storeQuery]="null"
                       bindValue="id"
                       placeholder="Stores"></form-group-select>
  </form-group-context>

  <form-group-context label="Active" formControlName="active">
    <form-group-simple type="checkbox" name="active"></form-group-simple>
  </form-group-context>

  <form-group-context label="Actions" [hidden]="actions.isEmpty" #actions>
    <ng-content select="[form][actions]"></ng-content>
  </form-group-context>

  <div class="mt-3">
    <ng-content></ng-content>
  </div>
</form>
